import { useEffect, useState } from 'react';
import api, { RARITY_META, CATEGORY_IMAGES } from '../lib/api';
import { Award } from 'lucide-react';

export default function Achievements() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get('/achievements').then(r => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-5" data-testid="achievements-root">
      <h2 className="font-serif text-3xl">Achievements</h2>
      <div className="grid grid-cols-2 gap-3">
        {items.map(a => {
          const pct = Math.round((a.progress / a.target) * 100);
          return (
            <div key={a.code} className={`rounded-3xl bg-card border ${a.unlocked ? 'border-accent/40' : 'border-white/5'} p-4`} data-testid={`achievement-${a.code}`}>
              <Award className={`w-6 h-6 mb-2 ${a.unlocked ? 'text-accent' : 'text-muted-foreground'}`} strokeWidth={1.5} />
              <p className="font-serif text-base">{a.title}</p>
              <p className="text-xs text-muted-foreground mt-1 leading-snug">{a.description}</p>
              <div className="mt-3 h-1 bg-white/10 rounded-full overflow-hidden"><div className="h-full bg-accent" style={{ width: `${Math.min(100, pct)}%` }} /></div>
              <p className="text-[10px] font-mono text-muted-foreground mt-1">{a.progress}/{a.target} · +{a.xp_reward} XP</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
